
import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../src/components/Layout"
import Post from "../src/components/Post"
import { useSiteMetadata } from '../src/hooks'

import SEO from "../src/components/seo"




const Video = ({ src, title, ...props }) => (
    <div className="video">
      <iframe
        src={src}
        title={title}
        width={props.width || '100%'} height={props.height || '500px'}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        frameBorder="0"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen
      />
    </div>
  )
const Image = () => {
    const data = useStaticQuery(graphql`
      query {
            
    t0: file( absolutePath: {regex: "/pub/posts\/gatsby-astronaut.png$/"}) {
        childImageSharp {
             fluid(maxWidth: 1024) {
                ...GatsbyImageSharpFluid
                presentationWidth
              }

          }
        publicURL
        ext
 }

      }
      `)
      const NonStretchedImage = props => {
        let normalizedProps = props
        if (props.fluid && props.fluid.presentationWidth) {
          normalizedProps = {
            ...props,
            style: {
              ...(props.style || {}),
              maxWidth: props.fluid.presentationWidth,
              margin: "0 auto", // Used to center the image
            },
          }
         }
         return <Img {...normalizedProps}/>
      }
    // console.log({data:data.placeholderImage})
    return { 
        
    t0: data['t0'].childImageSharp ? NonStretchedImage(data['t0'].childImageSharp) : <img src={ data['t0'].publicURL }/>, // t0: <Img fluid={data['t0'].childImageSharp.fluid} />, 
    t0_: data['t0'].publicURL,
    
     }
  }

const postTitle = `📝 How to make a great post
`

const SecondPage = ({pageContext}) => {
  const { title: siteTitle, subtitle: siteSubtitle } = useSiteMetadata();
  const { item } = pageContext
  return <Layout title={`${postTitle} - ${siteTitle}`} socialImage={Image().t0_}>
    <SEO title={postTitle} />
    <Post PUBDATE={item.PUBDATE} title={postTitle} >
    <h2>First post </h2><p>Use the <strong>most</strong> of the <a href="https://docs.raku.org/language/pod">pod6</a> to make an <em>excellent</em> post! </p><p>For codes samples, like this: </p><code><pre>{`  sub demo {
    `}<strong>{`say`}</strong>{` 'Hello `}<var>{`name`}</var>{`';
  }
`}</pre></code><p>use <code>=code</code> block: </p><code><pre>{`    =begin code :allow<B R>
    sub demo {
        B<say> 'Hello R<name>';
    }
    =end code
`}</pre></code><p>Insert image <code>=Image gatsby-astronaut.png</code> : </p>{Image().t0}<p>For insert video use <code>=Video</code> block. The following examples are equivalents: </p><code><pre>{`
=for Video  :width(958) :height("539")
= :src("https://www.youtube.com/embed/20SHvU2PKsM")
= :title("Title of the video ")

=for Video  :width(958) :height("539") :title("Title of the video ")
https://www.youtube.com/embed/20SHvU2PKsM

`}</pre></code><p>The short form is: </p><p><code>=Video https:&#x2F;&#x2F;www.youtube.com&#x2F;embed&#x2F;20SHvU2PKsM</code> </p><Video  width="958" height="539" title="Title of the video " src="https:&#x2F;&#x2F;www.youtube.com&#x2F;embed&#x2F;20SHvU2PKsM" /><p>Items levels </p><ul><li><p>Animal </p></li><ul><li><p>Vertebrate </p></li><li><p>Invertebrate </p></li></ul><li><p>Phase </p></li><ul><li><p>Solid </p></li><li><p>Liquid </p></li><li><p>Gas </p></li><li><p>Chocolate </p></li></ul></ul><p>Table:  </p><table><caption>Super table!</caption><tr><th>               Superhero    </th><th> Secret Identity        </th><th>  Superpower</th></tr><tr><td> The Shoveller              </td><td> <em>Eddie Stevens</em>                 </td><td>    King Arthur&#x27;s singing shovel</td></tr><tr><td> Blue Raja    </td><td> Geoffrey Smith  </td><td> <strong>Master</strong> of cutlery</td></tr><tr><td> Mr Furious                 </td><td> Roy Orson                        </td><td> Ticking time bomb of fury</td></tr><tr><td> The Bowler   </td><td> Carol Pinnsler  </td><td> Haunted bowling ball</td></tr></table>
    </Post>
  </Layout>
}

export default SecondPage
